module.exports = __webpack_public_path__ + "static/media/list.6a1f000b.svg";